import { FC, useState } from "react";
import AnchorTarget from "components/official/AnchorTarget";
import Section from "components/gonzo/parts/Section";
import styled from "styled-components";
import MoreButton from "components/gonzo/parts/MoreButton";
import Headline from "components/gonzo/parts/Headline";
import Content from "components/gonzo/parts/Content";

const News: FC = () => {
  const [showsMore, setShowsMore] = useState(false);
  const toggleShowsMore = () => setShowsMore(!showsMore);
  return (
    <Section>
      <AnchorTarget id="news" />
      <Headline src={["/image/lp/gonzo/news/news_title_1.png", "/image/lp/gonzo/news/news_title_2.png"]} alt="ニュース" />
      <Content>
        <NewsList>
          {EXPOSED_NEWS_LIST.map((news, index) => (
            <NewsArea key={index}>
              {news.isNew && <NewIcon src="/image/lp/gonzo/news/news_line_new.png" />}
              <DateArea>{news.date}</DateArea>
              <NewsText>{news.text}</NewsText>
            </NewsArea>
          ))}
          {showsMore &&
            HIDDEN_NEWS_LIST.map((news, index) => (
              <NewsArea key={index}>
                <DateArea>{news.date}</DateArea>
                <NewsText>{news.text}</NewsText>
              </NewsArea>
            ))}
        </NewsList>
        {HIDDEN_NEWS_LIST.length > 0 && (
          <ButtonArea>
            <MoreButton opened={showsMore} onClick={toggleShowsMore} />
          </ButtonArea>
        )}
      </Content>
    </Section>
  );
};
export default News;

const EXPOSED_NEWS_LIST: News[] = [
  { date: "2022.09.18", text: "「爆裂天使」「超重神グラヴィオン」のキャンペーン開催", isNew: true },
  { date: "2022.09.11", text: "GONZO30th アニバーサリークラファン開始", isNew: false },
  { date: "2022.09.11", text: "「LASTEXILE」「ラストエグザイル-銀翼のファム-」のキャンペーン開催", isNew: false },
  { date: "2022.09.04", text: "「ぼくらの」「カレイドスター」のキャンペーン開催", isNew: false },
  { date: "2022.08.28", text: "「ブレイブストーリー」「かくりよの宿飯」のキャンペーン開催", isNew: false },
];
const HIDDEN_NEWS_LIST: News[] = [
  { date: "2022.08.26", text: "GONZO30th アニバーサリークラファンページ公開", isNew: false },
  { date: "2022.08.21", text: "「SAMURAI 7」「巌窟王」のキャンペーン開催", isNew: false },
  { date: "2022.08.14", text: "「アフロサムライ」「SoltyRei」のキャンペーン開催", isNew: false },
  { date: "2022.08.07", text: "「ストライクウィッチーズ」「蒼の彼方のフォーリズム」のキャンペーン開催", isNew: false },
  { date: "2022.08.06", text: "GONZO30th ANNIVERSARYの特設ページ公開", isNew: false },
];

interface News {
  date: string;
  text: string;
  isNew: boolean;
}

const NewsList = styled.ul`
  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
  @media screen and (min-width: 961px) {
    margin: 0 auto;
    max-width: 900px;
    font-size: 16px;
  }
  @media screen and (min-width: 1281px) {
    max-width: 1200px;
  }
`;

const NewsArea = styled.li`
  color: white;
  border-bottom: 1px solid white;
  position: relative;

  &:first-of-type {
    border-top: 1px solid white;
  }

  @media screen and (max-width: 960px) {
    padding: 24px 20px;
  }
  @media screen and (min-width: 961px) {
    width: 100%;
    padding: 30px;
    display: table;
  }
`;

const NewIcon = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  @media screen and (max-width: 960px) {
    height: 16px;
  }
  @media screen and (min-width: 961px) {
    height: 20px;
  }
`;

const DateArea = styled.div`
  color: #f5dc4c;
  @media screen and (max-width: 960px) {
    font-size: 1em;
    display: inline-block;
  }
  @media screen and (min-width: 961px) {
    width: 110px;
    display: table-cell;
    vertical-align: middle;
  }
`;

const NewsText = styled.p`
  font-weight: normal;
  margin-top: 5px;
  line-height: 1.428em;

  a {
    color: white;
    text-decoration: underline;
  }

  @media screen and (max-width: 960px) {
    margin-top: 8px;
    display: block;
  }
  @media screen and (min-width: 961px) {
    display: table-cell;
    vertical-align: middle;
    padding-left: 20px;
    font-size: 16px;
  }
`;

const ButtonArea = styled.div`
  text-align: center;
  @media screen and (max-width: 960px) {
    margin: 20px auto;
  }
  @media screen and (min-width: 961px) {
    margin: 40px auto;
  }
`;
